import { Route, Routes } from "react-router-dom"
import Setting from "../pages/main"
import { NewConfigFolio } from "../pages/create"
import { ReportFolioConfigProvider } from "../context"

const ReportSettingFolio = () => {
  return (
    <ReportFolioConfigProvider>
      <Routes>
        {/* DASHBOARD */}
        <Route path="/" element={<Setting />} />
        <Route path="/create" element={<NewConfigFolio />} />
        <Route path="/edit/:id" element={<NewConfigFolio />} />
      </Routes>
    </ReportFolioConfigProvider>
  )
}

export default ReportSettingFolio
